import { useMediaQuery as useChakraMediaQuery } from "@chakra-ui/react";

export function useMediaQuery(query: string | string[]): boolean[] {
  // Chakra v3 expects string[], normalize single query to array
  const queries = Array.isArray(query) ? query : [query];
  const matches = useChakraMediaQuery(queries);
  return matches;
}
